import type { UseFormReturn } from 'react-hook-form';
import { HeaderMenuLink } from '../header-menu-link/header-menu-link';

export interface MenuChildLink {
  id: string;
  label: string;
  href: string;
  active: boolean;
}

export interface MenuLink {
  id: string;
  label: string;
  children?: MenuChildLink[];
}

export interface FooterIcon {
  id: string;
  name: string;
  iconName: string;
  href: string;
  active: boolean;
  languages?: Record<string, string>;
  type?: 'futures';
}

export interface FooterMenuConfig {
  links: MenuLink[];
  icons: FooterIcon[];
}

export const defaultHeaderMenuLinks: HeaderMenuLink[] = [
  {
    id: '1',
    label: 'Overview',
    meta: {
      icon: 'HeaderRocket',
      label: 'Scale Up',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque neque massa, suscipit vel convallis eget, volutpat id lorem.',
      images: { en: 'scaleUpImage' },
    },
    children: [
      {
        id: '11',
        label: 'Portfolio',
        href: '/portfolio',
        active: true,
      },
      {
        id: '12',
        label: 'Playbook',
        href: '/playbook',
        active: true,
      },
      {
        id: '13',
        label: 'Achievements',
        href: '/achievements',
        active: true,
      },
      {
        id: '14',
        label: 'Orders',
        href: '/orders',
        active: true,
      },
    ],
  },
  {
    id: '2',
    label: 'Community',
    meta: {
      icon: 'Community',
      label: 'Community',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque neque massa, suscipit vel convallis eget, volutpat id lorem.',
      images: { en: 'top100WinnersImage' },
    },
    children: [
      {
        id: '22',
        label: 'Contests',
        href: '/contests',
        active: true,
      },
      {
        id: '23',
        label: 'Trade Talks',
        href: '/trade-talk',
        active: true,
      },
      {
        id: '24',
        label: 'Community Stats',
        href: '/community-stats',
        active: true,
      },
    ],
  },
  {
    id: '3',
    label: 'Academy',
    meta: {
      icon: 'Academy',
      label: 'Academy',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque neque massa, suscipit vel convallis eget, volutpat id lorem.',
      images: { en: 'academyImage' },
    },
    children: [
      {
        id: '31',
        label: 'VOD',
        href: '/hub-vod',
        active: true,
      },
      {
        id: '32',
        label: 'ABL',
        href: '/abl',
        active: false,
      },
      {
        id: '33',
        label: 'Tradedelicious',
        href: '/tradedelicious',
        active: true,
      },
      {
        id: '34',
        label: 'BOD',
        href: '/bod',
        active: false,
      },
    ],
  },
];

const defaultFooterLinks: MenuLink[] = [
  {
    id: 'resources',
    label: 'Resources',
    children: [
      {
        id: 'downloads',
        label: 'Downloads',
        href: '/downloads',
        active: true,
      },
      {
        id: 'autochartist',
        label: 'Autochartist',
        href: '/autochartist',
        active: true,
      },
      {
        id: 'asset_specifications',
        label: 'Asset Specifications',
        href: '/asset-specifications',
        active: true,
      },
      {
        id: 'trading_platform_web',
        label: 'Trading Platform - web',
        href: '/trading-platform',
        active: true,
      },
    ],
  },
  {
    id: 'legal',
    label: 'Legal',
    children: [
      {
        id: 'terms_conditions',
        label: 'Terms & Conditions',
        href: '/terms',
        active: true,
      },
      {
        id: 'privacy_policy',
        label: 'Privacy Policy',
        href: '/privacy',
        active: true,
      },
      {
        id: 'copyright_infringement_policy',
        label: 'Copyright Infringement Policy',
        href: '/copyright',
        active: true,
      },
      {
        id: 'disclaimer',
        label: 'Disclaimer',
        href: '/disclaimer',
        active: true,
      },
    ],
  },
  {
    id: 'about',
    label: 'About Us',
    children: [
      {
        id: 'refer_a_friend',
        label: 'Refer a Friend',
        href: '/refer',
        active: true,
      },
      {
        id: 'faq',
        label: "FAQ's",
        href: '/faq',
        active: true,
      },
      {
        id: 'contact_us',
        label: 'Contact Us',
        href: '/contact',
        active: true,
      },
    ],
  },
];

const defaultFooterIcons5ers: FooterIcon[] = [
  {
    id: '1',
    name: 'Facebook',
    iconName: 'FacebookLogo',
    href: 'https://www.facebook.com/the5ersproptrading/',
    active: true,
  },
  {
    id: '2',
    name: 'X',
    iconName: 'XLogo',
    href: 'https://x.com/the5erstrading',
    active: true,
  },
  {
    id: '3',
    name: 'YouTube',
    iconName: 'YoutubeLogo',
    href: 'https://www.youtube.com/channel/UCyvjJo0YumXPtxc_FlKWcBQ',
    active: true,
  },
  {
    id: '4',
    name: 'LinkedIn',
    iconName: 'LinkedinLogo',
    href: 'https://www.linkedin.com/company/the5-ers---trading-group/',
    active: true,
  },
  {
    id: '5',
    name: 'Instagram',
    iconName: 'InstagramLogo',
    href: 'https://www.instagram.com/the.5ers',
    active: true,
  },
  {
    id: '6',
    name: 'TikTok',
    iconName: 'TiktokLogo',
    href: 'https://www.tiktok.com/@the5ers.com?lang=en',
    active: true,
  },
];

const defaultFooterIconsTTP: FooterIcon[] = [
  {
    id: '1',
    name: 'Facebook',
    iconName: 'FacebookLogo',
    href: 'https://www.facebook.com/trade.the.pool/',
    active: true,
  },
  {
    id: '2',
    name: 'X',
    iconName: 'XLogo',
    href: 'https://x.com/TradeThePool',
    active: true,
  },
  {
    id: '3',
    name: 'YouTube',
    iconName: 'YoutubeLogo',
    href: 'https://www.youtube.com/@tradethepool',
    active: true,
  },
  {
    id: '4',
    name: 'LinkedIn',
    iconName: 'LinkedinLogo',
    href: 'https://www.linkedin.com/company/trade-the-pool/',
    active: true,
  },
  {
    id: '5',
    name: 'Instagram',
    iconName: 'InstagramLogo',
    href: 'https://www.instagram.com/tradethepool',
    active: true,
  },
  {
    id: '6',
    name: 'TikTok',
    iconName: 'TiktokLogo',
    href: 'https://www.tiktok.com/@tradethepool',
    active: true,
  },
  {
    id: '7',
    name: 'Discord',
    iconName: 'DiscordLogo',
    href: 'https://discord.com/invite/eH67W5RtEA',
    active: true,
  },
  {
    id: '8',
    name: 'YouTube',
    iconName: 'YoutubeLogo',
    href: 'https://www.youtube.com/@The5ersFutures',
    active: true,
    type: 'futures',
  },
  {
    id: '9',
    name: 'Instagram',
    iconName: 'InstagramLogo',
    href: 'https://www.instagram.com/5ersfutures/',
    active: true,
    type: 'futures',
  },
  {
    id: '10',
    name: 'TikTok',
    iconName: 'TiktokLogo',
    href: 'https://www.tiktok.com/@the5ersfutures',
    active: true,
    type: 'futures',
  },
  {
    id: '11',
    name: 'Discord',
    iconName: 'DiscordLogo',
    href: 'https://discord.com/invite/RxpaJ3Jydj',
    active: true,
    type: 'futures',
  },
];

// Default footer config for 5ers (icons + futures icons in single array)
export const defaultFooterConfig: FooterMenuConfig = {
  links: defaultFooterLinks,
  icons: defaultFooterIcons5ers,
};

// Default footer config for TTP
export const defaultFooterConfigTTP: FooterMenuConfig = {
  links: defaultFooterLinks,
  icons: defaultFooterIconsTTP,
};

export type FooterFormValues = {
  footerConfig: {
    links: MenuLink[];
    icons: FooterIcon[];
  };
};

export type EditFormValues = {
  form: UseFormReturn<FooterFormValues>;
  setValue: UseFormReturn<FooterFormValues>['setValue'];
};
